import React, { useState, useEffect } from "react";
import moment from "moment";
import { Line, Bar } from "react-chartjs-2";
import FETCH from "../../../utils/fetch";
import "../AssetsDashboard.css";
import assetHomeIcon from "../../../assets/images/asset.png";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import { ChartColors } from "../../../components/ChartColors";
import DASHBOARD_API from "../../../apis/dashboard.api";
export const AssetsReport = (props) => {
  const [loading, setLoading] = useState(false);
  const [assetsList, setAssetsList] = useState([]);
  const [assetsName, setAssetsName] = useState([]);
  const [assetsValues, setAssetsValues] = useState([]);
  const [assetsAmount, setAssetsAmount] = useState(null);
  const [monetaryValue, setMonetaryValue] = useState(0);
  const [monetaryValueCollection, setMonetaryValueCollection] = useState(0);
  const [monetaryValueInventory, setMonetaryValueInventory] = useState(0);
  const getAssetsList = async () => {
    try {
        setLoading(true);
        setAssetsName([]);
        setAssetsValues([]);
        setAssetsAmount(null);
        let datares = await FETCH.post({
          url: "client-module-service/client-module/list",
          id: `?module=Asset&page=1&limit=10`,
          body: {},
        });
        if (datares && datares.records) {
          setAssetsList(datares.records);

          datares.records.map((item) => {
            setAssetsValues((prevState) => [
              ...prevState,
              item["Monetary Value"] ? item["Monetary Value"] : 0,
            ]);
            setAssetsName((prevState) => [...prevState, item["Name of Asset"]]);
            setAssetsAmount(
              (prevAmount) =>
                prevAmount +
                (item["Monetary Value"] ? item["Monetary Value"] : 0)
            );
          });
        }
        setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  console.log("assestName", assetsName);
  console.log("assestValue", assetsValues);

  useEffect(() => {
    getAssetsList();
    getAll();
  }, [props.sharedState]);
  const data = {
    labels: assetsName && assetsName,
    datasets: [
      {
        label: "Monetary Value",
        data: assetsValues && assetsValues,
        fill: false,
        backgroundColor: assetsValues && assetsValues.map((_, index) =>
          ChartColors[index % ChartColors.length] // Cycle through ChartColors
        ),
        borderColor: assetsValues && assetsValues.map((_, index) =>
          ChartColors[index % ChartColors.length] // Same for borderColor
        ),
        // backgroundColor: (context) => {
        //   const ctx = context.chart.ctx;
        //   const gradient = ctx.createLinearGradient(0, 0, 0, 550);
        //   gradient.addColorStop(0, "rgba(135,153,252,1)");
        //   gradient.addColorStop(1, "rgba(135,153,252,0)");
        //   return gradient;
        // },
        // // backgroundColor: "#E6F1FF",
        // borderColor: "#2A3DA3",
      },
    ],
  };
console.log("data22",data);
const getMonetaryValueAssets = async () => {
  try {
    setLoading(true);
    setMonetaryValue(0);
    const moduleName="Assets";
    let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
    if (data && data.data && data.data[0] && data.data[0].monetary && data.data[0].monetary !== null) {
      setMonetaryValue(data.data[0].monetary);
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
const getMonetaryValueInventory = async () => {
  try {
    setLoading(true);
    setMonetaryValueInventory(0);
    const moduleName="Property";
    let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
    if (data && data.data && data.data[0] && data.data[0].monetary && data.data[0].monetary !== null) {
      setMonetaryValueInventory(data.data[0].monetary);
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
const getMonetaryValueCollection = async () => {
  try {
    setLoading(true);
    setMonetaryValueCollection(0);
    const moduleName="Collection";
    let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
    if (data && data.data && data.data[0] && data.data[0].monetary && data.data[0].monetary !== null) {
      setMonetaryValueCollection(data.data[0].monetary);
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log(error);
  }
};
const getAll = async () => {
  setLoading(true);
  await getMonetaryValueAssets();
  await getMonetaryValueCollection();
  await getMonetaryValueInventory();
  setLoading(false);

};
useEffect(() => {
  getAll();
}, []);
  return (
    <React.Fragment>
      <div className="reportCard1">
        <h3 className="Reportheading">Assets</h3>
        <div className="asset-home-icon-container">
          <div className="asset-home-icon">
            <img src={assetHomeIcon} alt="" />
          </div>
          <span style={{fontSize:"28px",fontWeight:"500", wordBreak:"break-all"}}>
            ${((+monetaryValue) + (+monetaryValueCollection) + (+monetaryValueInventory)).toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        </div>
        <div className="reprotcardRow">
          <div>
            <div className="reportrow">
              <div className="reportrowData">
                <span className="reportTitle"> Client Name</span>
                <span className="reportsubTitle">
                  {" "}
                  {localStorage.getItem("User") ? (
                    localStorage.getItem("User")
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}
                </span>
              </div>
              <div className="reportrowData">
                <span className="reportTitle"> Plan Nickname </span>
                <span className="reportsubTitle"> First Plan</span>
              </div>
            </div>
            <div className="reportrow2">
              <div className="reportrowData">
                <span className="reportTitle"> Today's Date </span>
                <span className="reportsubTitle">
                  {" "}
                  {moment().format("MM/DD/YYYY")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="reportCard2" style={{position:"relative"}}>
        <h1 className="liablitycardheading">All Assets</h1>
        <div style={{ marginTop: "1rem" }}>
        <Bar
            data={data}
            height={300}
            options={{
              legend: {
              display: false,
              },
              
              maintainAspectRatio: false,
              responsive: true,
              scales: {
                
                xAxes: [
                  {
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      callback: function (value) {
                        return new Intl.NumberFormat('en-US', {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);
                      }
                    }
                  }
                ]
              },

            }}
          />
        {/*  <Line
            data={data}
            height={100}
            options={{
              legend: {
                display: false,
              },

              scales: {
                xAxes: [
                  {
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
                yAxes: [
                  {
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
              },
              plugins: {},
            }}
          /> */}
        </div>
        <NewLoader isLoading={loading} />

      </div>
    </React.Fragment>
  );
};
